<div class="flex flex-col gap-4">
  @for (
    entry of sortedEntries();
    track entry.externalReference;
    let index = $index
  ) {
    @if (isDateEntry(entry)) {
      <aw-date-input
        [id]="'additional-entry-' + index"
        [label]="entry.name ?? ''"
        [formControl]="controls().at(index).controls.value"
        [showTimePicker]="isDateTimeEntry(entry)">
        {{
          textStore.texts()
            | filterTexts
              : getDateErrorRelationType(entry)
              : EEntityType.generalArea
            | language
        }}
      </aw-date-input>
    } @else {
      @switch (getEntryDataType(entry)) {
        @case ('Zahl') {
          <aw-number-input
            [id]="'additional-entry-' + index"
            [label]="entry.name ?? ''"
            [formControl]="controls().at(index).controls.value">
          </aw-number-input>
        }

        @case ('Nummer') {
          <aw-text-input
            [id]="'additional-entry-' + index"
            [label]="entry.name ?? ''"
            [formControl]="controls().at(index).controls.value">
          </aw-text-input>
        }

        @case ('Text') {
          <aw-text-input
            [id]="'additional-entry-' + index"
            [label]="entry.name ?? ''"
            [formControl]="controls().at(index).controls.value">
          </aw-text-input>
        }

        @case ('Uhrzeit') {
          <aw-text-input
            [id]="'additional-entry-' + index"
            [label]="entry.name ?? ''"
            [inputType]="'time'"
            [formControl]="controls().at(index).controls.value">
            {{
              textStore.texts()
                | filterTexts
                  : ERelationType.timeInputError
                  : EEntityType.generalArea
                | language
            }}
          </aw-text-input>
        }

        @case ('Auswahl') {
          <aw-drop-down
            [id]="'additional-entry-' + index"
            [label]="entry.name ?? ''"
            [formControl]="controls().at(index).controls.value"
            [options]="entry.options ?? []">
          </aw-drop-down>
        }
      }
    }
  }
</div>
